import type { TooltipColor, TooltipProps as TooltipNewProps } from './Tooltip';

export type TooltipKind = TooltipColor;

export interface OldTooltipProps
  extends Omit<TooltipNewProps, 'color' | 'shouldCloseOnOutsideClick' | 'closeDelay' | 'open'> {
  /** @deprecated color를 대신 사용해주세요. */
  kind?: TooltipColor;
  /** @deprecated shouldCloseOnOutsideClick을 대신 사용해주세요. */
  canClickOutside?: boolean;
  /** @deprecated closeDelay를 대신 사용해주세요. */
  close_delay?: number;
  /** @deprecated open을 대신 사용해주세요. */
  opened?: boolean;
}

export function convertOldTooltipProps(props: OldTooltipProps): TooltipNewProps {
  const { kind, canClickOutside, close_delay, opened, ...restProps } = props;

  return {
    ...restProps,
    color: kind,
    shouldCloseOnOutsideClick: canClickOutside,
    closeDelay: close_delay,
    open: opened,
  };
}
